import { HStack } from '@chakra-ui/react'

export const NavigationMenu = ({ children, ...props }) => {
  return (
    <HStack gap={2} pl="20px" pr="20px" justifySelf="center" {...props}>
      {children}
    </HStack>
  )
}
